import angular from 'angular';
import { charsRemainComponent } from './charsRemainComponent';
import 'components/sharpr/zIndex/top/zIndexTopModule';

angular.module('sh.charsRemain', ['sh.zIndexTop']).component('shCharsRemain', charsRemainComponent());
